import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to gain buy-in and commitment.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">isn't it interesting?</span>
                                            </div>
                                            <p>What do you need to survive?</p>


                                            <div className="border_subtitle">What motivates those around you?
                                            </div>
                                            <p>Identifying what makes others tick will inform you of how best to
                                                gain their buy-in and commitment. Researchers have studied in
                                                great detail how and why people make commitments, and to what
                                                ends they make those commitments.</p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">A hierarchy of needs</div>
                                                <p>In 1971, Abraham Maslow<a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300"><sup>1</sup></a> proposed
                                                    the theory that we are driven by a hierarchy of needs and
                                                    that humans strive for the highest level of personal
                                                    attainment (the highest being called ‘self-actualisation’).
                                                    This theory is still used now, and a modern study in
                                                    Israel<a className="superscripttext supLinesapce"
                                                             href="further_info.php?course=300"><sup>2</sup></a> showed
                                                    a correlation between self-actualisation and a positive
                                                    attitude towards, and success in finding, employment.</p>
                                                <div className="paraspace"><p>Maslow developed a hierarchy with
                                                    five levels of basic needs, based on the notion that
                                                    individuals progress through the levels but will not
                                                    progress to the next level until the needs of the first have
                                                    been satisfied, and so on. These needs are:</p></div>
                                                <ul className="greenbullet-list ">
                                                    <li>Physiological – where we initially seek to satisfy needs
                                                        or things (like food and shelter).
                                                    </li>
                                                    <li>Safety – at work this includes physical safety (such as
                                                        clothing that is protective, protection against
                                                        unemployment or loss of income through sickness).
                                                    </li>
                                                    <li>Social – includes the need to belong (at work this could
                                                        be through working alongside colleagues who are
                                                        supportive, communicative and team-orientated).
                                                    </li>
                                                    <li>Esteem – includes being given recognition for a job well
                                                        done, as many seek the esteem and respect of others.
                                                        Promotion at work might achieve this.
                                                    </li>
                                                    <li className="zeroPaddingUl4">Self-actualisation – (the
                                                        need to realise one’s full potential) – this is often
                                                        measured by the extent of success and/or challenge at
                                                        work.
                                                    </li>
                                                </ul>
                                            </div>


                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page2')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}